import { UUID } from '@/plugins/common'
import _ from 'lodash'

export default class Action {
  id = ''
  name = ''
  requiredRequired = false

  constructor (args = {}) {
    _.merge(this, args)
  }

  static create (args) {
    args.id = '_' + UUID.create()
    args.type = args.type || '流转'
    let action = new Action(args)
    return action
  }

  static load (args) {
    let action = new Action(args)
    return action
  }
}



// WEBPACK FOOTER //
// ./src/store/process/action.js